<script>
import CardItem from '@/components/list/CardItem'
export default {
  functional: true,
  components: {
    CardItem,
  },
  props: {
    form: Object,
    headers: Array,
    hideAlert: {
      type: Function,
      default: () => {},
    },
  },
  render: (h, { props }) => {
    const { form, headers, hideAlert } = props
    const doHideAlert = value => {
      hideAlert()
    }

    const errorAlert = form.hasError
      ? <v-alert
        value={form.showAlert}
        type="error"
        dismissible
        class="my-0"
        on-input={ doHideAlert }>
        { form.errors.message }
        <div>{ form.errors.errors }</div>
      </v-alert>
      : null

    const successAlert = form.saved
      ? <v-alert
        value={form.showAlert}
        type="success"
        dismissible
        class="my-0"
        on-input={ doHideAlert }>
          OK
      </v-alert>
      : null

    let usableHeaders = headers.filter(header => header.inDetail === undefined)
    return (
      <div>
        { errorAlert }
        { successAlert }
        <v-container fluid fill-height>
          <v-layout align-center justify-center>
            <v-flex xs12 md8>
              <CardItem
                item={ form.data }
                selection={[]}
                headers={ usableHeaders }
                actions={[]}
                hasActions={false}
                isDetail={true}
              />
            </v-flex>
          </v-layout>
        </v-container>
      </div>
    )
  },
}
</script>

<style scoped>
.truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
